/* NubeTiendas Natura — Theme JS */

(function() {

  /* Sticky header */
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 10);
    });
  }

  /* Mobile menu */
  const mobileToggle = document.querySelector('.header-mobile-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileOverlay = document.querySelector('.mobile-menu__overlay');
  const mobileClose = document.querySelector('.mobile-menu__close button');

  function openMenu() { mobileMenu?.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeMenu() { mobileMenu?.classList.remove('open'); document.body.style.overflow = ''; }

  mobileToggle?.addEventListener('click', openMenu);
  mobileOverlay?.addEventListener('click', closeMenu);
  mobileClose?.addEventListener('click', closeMenu);

  /* Cart drawer */
  const cartOverlay = document.querySelector('.cart-overlay');
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartClose = document.querySelector('.cart-drawer__close');

  function openCart() {
    cartOverlay?.classList.add('open');
    cartDrawer?.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    cartOverlay?.classList.remove('open');
    cartDrawer?.classList.remove('open');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('.js-open-cart').forEach(el => el.addEventListener('click', openCart));
  cartOverlay?.addEventListener('click', closeCart);
  cartClose?.addEventListener('click', closeCart);

  /* Update cart count from DOM */
  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  /* Add to cart */
  document.querySelectorAll('.product-card__add, .js-add-to-cart').forEach(btn => {
    btn.addEventListener('click', async function(e) {
      e.preventDefault();
      const variantId = this.dataset.variantId;
      if (!variantId) return;
      const originalText = this.innerHTML;
      this.innerHTML = '✓';
      this.classList.add('added');
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (res.ok) {
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          updateCartCount(cart.item_count);
          setTimeout(() => { this.innerHTML = originalText; this.classList.remove('added'); }, 1400);
          openCart();
          loadCartDrawer();
        }
      } catch(err) {
        this.innerHTML = originalText;
        this.classList.remove('added');
      }
    });
  });

  /* Load cart drawer contents */
  async function loadCartDrawer() {
    const body = document.querySelector('.cart-drawer__body');
    const totalEl = document.querySelector('.cart-drawer__total-price');
    if (!body) return;
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      if (cart.item_count === 0) {
        body.innerHTML = '<div class="cart-empty"><p>Tu carrito está vacío</p><a href="/collections/all" class="btn btn-secondary btn-sm">Ver productos</a></div>';
        if (totalEl) totalEl.textContent = '';
        return;
      }
      let html = '';
      cart.items.forEach(item => {
        html += `<div class="cart-item">
          <div class="cart-item__image"><img src="${item.image}" alt="${item.title}" loading="lazy"></div>
          <div class="cart-item__info">
            <p class="cart-item__title">${item.title}</p>
            <p class="cart-item__price">${formatMoney(item.final_price)}</p>
            <button class="cart-item__remove" data-key="${item.key}">Eliminar</button>
          </div>
        </div>`;
      });
      body.innerHTML = html;
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
      body.querySelectorAll('.cart-item__remove').forEach(btn => {
        btn.addEventListener('click', async function() {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: this.dataset.key, quantity: 0 })
          });
          const updatedCart = await (await fetch('/cart.js')).json();
          updateCartCount(updatedCart.item_count);
          loadCartDrawer();
        });
      });
    } catch(err) { console.error('Cart error', err); }
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(cents / 100);
  }

  /* Countdown timer */
  const countdowns = document.querySelectorAll('[data-countdown]');
  countdowns.forEach(el => {
    const endDate = new Date(el.dataset.countdown);
    function tick() {
      const diff = endDate - new Date();
      if (diff <= 0) { el.innerHTML = '<span style="color:rgba(255,255,255,0.6);font-size:14px">Oferta finalizada</span>'; return; }
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      const pad = n => String(n).padStart(2, '0');
      el.innerHTML = `
        <div class="countdown-block"><span class="countdown-num">${pad(h)}</span><span class="countdown-label">Horas</span></div>
        <div class="countdown-block"><span class="countdown-num">${pad(m)}</span><span class="countdown-label">Min</span></div>
        <div class="countdown-block"><span class="countdown-num">${pad(s)}</span><span class="countdown-label">Seg</span></div>`;
    }
    tick(); setInterval(tick, 1000);
  });

  /* Wishlist toggle */
  document.querySelectorAll('.product-card__wishlist').forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const isLiked = this.getAttribute('aria-pressed') === 'true';
      this.setAttribute('aria-pressed', String(!isLiked));
      this.innerHTML = isLiked ? '🤍' : '❤️';
    });
  });

  /* Product gallery thumbnails */
  document.querySelectorAll('.product-gallery__thumb').forEach(thumb => {
    thumb.addEventListener('click', function() {
      const src = this.querySelector('img')?.src;
      const mainImg = document.querySelector('.product-gallery__main img');
      if (mainImg && src) {
        mainImg.src = src.replace(/width=\d+/, 'width=800');
        document.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('active'));
        this.classList.add('active');
      }
    });
  });

  /* Scroll reveal */
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.product-card, .category-card, .testimonial-card').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(16px)';
    el.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
    observer.observe(el);
  });

  /* Newsletter form */
  document.querySelector('.js-newsletter-form')?.addEventListener('submit', function(e) {
    e.preventDefault();
    const btn = this.querySelector('button[type="submit"]');
    const input = this.querySelector('input[type="email"]');
    if (!input?.value) return;
    btn.textContent = '¡Gracias!';
    btn.style.background = '#2d9e5f';
    input.value = '';
    setTimeout(() => { btn.textContent = 'Suscribirme'; btn.style.background = ''; }, 3000);
  });

})();
